import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ServiceSidebar = ({ service, onBookNow, onGetQuote }) => {
  return (
    <div className="space-y-6">
      {/* Quick Booking Card */}
      <div className="bg-white rounded-xl shadow-elevation-2 p-6 border border-border">
        <h3 className="text-lg font-semibold text-text-primary mb-4">
          Quick Booking
        </h3>
        
        <div className="space-y-4">
          <div className="text-center">
            <div className="text-2xl font-bold text-primary">${service?.startingPrice}</div>
            <div className="text-sm text-text-secondary">Starting price</div>
          </div>
          
          <Button
            variant="default"
            fullWidth
            onClick={onBookNow}
            iconName="Calendar"
            iconPosition="left"
          >
            Book This Service
          </Button>
          
          <Button
            variant="outline"
            fullWidth
            onClick={onGetQuote}
            iconName="Calculator"
            iconPosition="left"
          >
            Get Custom Quote
          </Button>
        </div>
      </div>
      {/* Service Highlights */}
      <div className="bg-white rounded-xl shadow-elevation-2 p-6 border border-border">
        <h3 className="text-lg font-semibold text-text-primary mb-4 flex items-center">
          <Icon name="CheckCircle" size={20} color="var(--color-success)" className="mr-2" />
          What's Included
        </h3>
        
        <div className="space-y-3">
          {service?.includes?.map((item, index) => (
            <div key={index} className="flex items-start space-x-3">
              <Icon name="Check" size={16} color="var(--color-success)" className="mt-0.5 flex-shrink-0" />
              <span className="text-sm text-text-secondary">{item}</span>
            </div>
          ))}
        </div>
      </div>
      {/* Service Details */}
      <div className="bg-white rounded-xl shadow-elevation-2 p-6 border border-border">
        <h3 className="text-lg font-semibold text-text-primary mb-4">
          Service Details
        </h3>
        
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <Icon name="Clock" size={16} color="var(--color-text-secondary)" />
              <span className="text-sm text-text-secondary">Duration</span>
            </div>
            <span className="text-sm font-medium text-text-primary">{service?.duration}</span>
          </div>
          
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <Icon name="Users" size={16} color="var(--color-text-secondary)" />
              <span className="text-sm text-text-secondary">Team Size</span>
            </div>
            <span className="text-sm font-medium text-text-primary">{service?.teamSize}</span>
          </div>
          
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <Icon name="MapPin" size={16} color="var(--color-text-secondary)" />
              <span className="text-sm text-text-secondary">Service Area</span>
            </div>
            <span className="text-sm font-medium text-text-primary">{service?.serviceArea}</span>
          </div>
          
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <Icon name="Shield" size={16} color="var(--color-text-secondary)" />
              <span className="text-sm text-text-secondary">Guarantee</span>
            </div>
            <span className="text-sm font-medium text-text-primary">{service?.guarantee}</span>
          </div>
        </div>
      </div>
      {/* Emergency Service */}
      <div className="bg-gradient-to-r from-error/10 to-warning/10 rounded-xl p-6 border border-error/20">
        <div className="flex items-center space-x-3 mb-3">
          <div className="w-10 h-10 bg-error rounded-lg flex items-center justify-center">
            <Icon name="Zap" size={20} color="white" />
          </div>
          <div>
            <h4 className="font-semibold text-text-primary">Emergency Service</h4>
            <p className="text-sm text-text-secondary">Available 24/7</p>
          </div>
        </div>
        
        <p className="text-sm text-text-secondary mb-4">
          Need immediate assistance? Our emergency team is ready to help.
        </p>
        
        <Button
          variant="destructive"
          fullWidth
          iconName="Phone"
          iconPosition="left"
        >
          Call Emergency Line
        </Button>
      </div>
      {/* Contact Info */}
      <div className="bg-white rounded-xl shadow-elevation-2 p-6 border border-border">
        <h3 className="text-lg font-semibold text-text-primary mb-4">
          Need Help?
        </h3>
        
        <div className="space-y-3">
          <div className="flex items-center space-x-3">
            <Icon name="Phone" size={16} color="var(--color-primary)" />
            <div>
              <div className="text-sm font-medium text-text-primary">(555) 123-4567</div>
              <div className="text-xs text-text-secondary">Mon-Fri 8AM-8PM</div>
            </div>
          </div>
          
          <div className="flex items-center space-x-3">
            <Icon name="MessageCircle" size={16} color="var(--color-primary)" />
            <div>
              <div className="text-sm font-medium text-text-primary">Live Chat</div>
              <div className="text-xs text-text-secondary">Available now</div>
            </div>
          </div>
          
          <div className="flex items-center space-x-3">
            <Icon name="Mail" size={16} color="var(--color-primary)" />
            <div>
              <div className="text-sm font-medium text-text-primary">info@clean360.com</div>
              <div className="text-xs text-text-secondary">24h response</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceSidebar;